import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView, captureUtmFromUrl, pushAnalyticsEvent } from "@/lib/analytics";

/**
 * Router-agnostic component mounted inside <BrowserRouter>.
 * Emits exactly one page_view per SPA navigation, and captures UTM/gclid
 * on the first visit.
 */
export default function AnalyticsRouterListener() {
  const location = useLocation();

  useEffect(() => {
    captureUtmFromUrl();
  }, []);

  useEffect(() => {
    // Defer to next tick so document.title (set by SEO component) is fresh.
    const t = setTimeout(() => {
      trackPageView(location.pathname + location.search);
      if (location.pathname === "/") {
        pushAnalyticsEvent("homepage_view", {
          page_type: "home",
          device_type: /Mobi|Android/i.test(navigator.userAgent) ? "mobile" : "desktop",
        }, { once: true, key: "homepage_view_" + location.pathname });
      }
    }, 50);
    return () => clearTimeout(t);
  }, [location.pathname, location.search]);

  return null;
}
